import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NewUser } from 'app/account/models/new-user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { CompanyService } from 'app/company/services/company.service';
import { UserService } from 'app/core/services/user.service';
import { Result } from 'app/core/models/result';
import { Location } from '@angular/common';
import { UserType } from 'app/account/models/user-type.model';
import { CompanyUserModel } from 'app/company/models/company-user-model';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';

@Component({
	templateUrl: './user-add.component.html',
	styleUrls: ['./user-add.component.css']
})
export class UserAddComponent implements OnInit {
	newUser: NewUser;
	errors: string[];
	submitAttempt = false;
    @ViewChild('registerForm', { static: false }) registerForm: NgForm;
	headerTitle: IHeaderTitle;
    isEmailValid: boolean;
    companyId: string;
    userTypes: UserType[];
    companyUser: CompanyUserModel;
    companyDetailsModel: CompanyDetailsModel;
    userType: number = null;

    constructor(
        private companyService: CompanyService,
		private accountService: UserService,
		private location: Location,
        private router: Router,
        private userService: UserService,
        private activatedRoute: ActivatedRoute
	) { }

	public register(): void {
		this.submitAttempt = true;
		if (this.registerForm.valid) {
			this.accountService.registerUser(this.newUser).subscribe(
                result => {
					this.open();
                    this.submitAttempt = false;

                    if (this.companyId && this.userType) {
                        this.companyUser = {
                            siteUserId: result,
                            companyId: this.companyId,
                            userTypeId: this.userType
                        } as CompanyUserModel;

                        this.addUserToCompany(this.companyUser);

                    } else {
                        this.router.navigate(['/account/users']);
                    }
				},
                error => {
                    this.handleRegisterError(error);
                }
			);
		}
	}

	ngOnInit(): void {
		this.newUser = {} as NewUser;
		this.isEmailValid = true;
		this.headerTitle = {
            title: 'Register new user',
			breadcrumbs: [{ title: 'Users', url: ['/account/users'] }]
        };

        this.userService.getUserTypes().subscribe(
            userTypes => this.userTypes = userTypes,
            error => {
                console.log(error);
            }
        );

        this.companyId = this.activatedRoute.snapshot.params['id'];
        if (this.companyId) {
            this.companyService.get(this.companyId).subscribe(companyInfo => {
                this.companyDetailsModel = companyInfo;
            });
        }

	}

	private remap(): void {
		//this.staticModal.open();
	}

	private handleRegisterError(error: Result) {
		this.errors = error.errorList;
	}

	closedSuccessfulModal(): void {
		this.router.navigate(['/account/users']);
	}

	checkEmail(): void {
		const existsSubscription = this.accountService.existsUserByEmail(this.newUser.email).subscribe(
			result => {
				this.isEmailValid = !result;
				existsSubscription.unsubscribe();
			}
		);
	}

    onBack(): void {
        this.location.back();
    }

	open(): void {
	}

	successClicked(): void {
	}

	onHide(): void {
    }


    addUserToCompany(companyUser): void {
        this.companyService.addUser(companyUser).subscribe(
            result => {
                this.router.navigate(['/company/' + this.companyId]);
            },
            error => {
                this.errors = (<Result>error).errorList;
            }
        );
    }

}
